<template>
  <div class="leaderboard-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>排行榜管理</span>
      </div>
      
      <div class="filter-section">
        <el-input
          v-model="gameid"
          placeholder="请输入 Game ID 过滤"
          style="width: 200px; margin-right: 10px;"
          clearable
          @change="fetchData"
          @clear="fetchData"
        ></el-input>
        
        <el-select v-model="platform" placeholder="选择平台" @change="fetchData" style="width: 150px; margin-right: 10px;" clearable>
          <el-option label="全部平台" value=""></el-option>
          <el-option label="Steam" value="steam"></el-option>
          <el-option label="Android" value="android"></el-option>
          <el-option label="iOS" value="ios"></el-option>
          <el-option label="Editor" value="editor"></el-option>
        </el-select>
        
        <el-button type="primary" @click="fetchData">查询</el-button>
      </div>

      <el-table :data="tableData" border style="width: 100%" v-loading="loading">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="gameid" label="Game ID" width="150"></el-table-column>
        <el-table-column prop="userid" label="用户ID" width="220"></el-table-column>
        <el-table-column prop="nickname" label="昵称" width="150"></el-table-column>
        <el-table-column prop="duration" label="时长/得分" width="120"></el-table-column>
        <el-table-column prop="platform" label="平台" width="120"></el-table-column>
        <el-table-column prop="created_at" label="记录时间" width="200"></el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button
              type="danger"
              size="mini"
              @click="handleDelete(scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import request from "@/net/request";

export default {
  name: "Leaderboard",
  data() {
    return {
      gameid: "",
      platform: "",
      loading: false,
      tableData: []
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      try {
        const res = await request.get("/stats/admin/leaderboard", {
          params: { 
            gameid: this.gameid,
            platform: this.platform
          }
        });
        this.tableData = res.data || [];
      } catch (error) {
        this.$message.error("获取排行榜数据失败: " + (error.response?.data?.message || error.message));
      } finally {
        this.loading = false;
      }
    },
    async handleDelete(row) {
      try {
        await this.$confirm("确定要删除这条记录吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        });
        
        await request.delete(`/stats/admin/leaderboard/${row.id}`);
        this.$message.success("删除成功");
        this.fetchData();
      } catch (error) {
        if (error !== "cancel") {
          this.$message.error("删除失败: " + (error.response?.data?.message || error.message));
        }
      }
    }
  }
};
</script>

<style scoped>
.leaderboard-container {
  padding: 20px;
}
.filter-section {
  margin-bottom: 20px;
}
</style>
